import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import { paths } from "../../config/router.config";
import { lab4services } from "../../services/wsclients/lab4services";
import { setTopupMonthlyViaPaymentLink, clearTopupMonthlyViaPaymentLink } from "../../utils/commons";
import ProcessFormView from '../../pages/register/ProcessFormView';
import CustomHeader from "../../components/CustomHeader";
import CustomFooter from "../../components/CustomFooter";
import { connection } from "../../config";

export default function PaymentLink(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [contact, setContact] = useState(null);
    const [contactName, setContactName] = useState(null);
    const [contactEmail, setContactEmail] = useState(null);
    const [outstandingAmount, setOutstandingAmount] = useState([]);
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    useLayoutEffect(() => {
        clearTopupMonthlyViaPaymentLink();
    }, []);

    useEffect(() => {
        onLoad();
    }, []);
    
    const onLoad = async () => {
        onShowLoading(true);
        var url = new URL(window.location.href);
        
        console.log("PaymentLink url===", url);
        let pathnames = url && url.pathname ? url.pathname.split('/') : [];        
        let contactCode = pathnames.length >= 1 ? pathnames[pathnames.length - 1] : null;
        console.log("PaymentLink contactCode===", contactCode);
        if(contactCode){
            await loadContactOutStandingAmount(contactCode);
        }        

        onShowLoading(false);
    }
    const loadContactOutStandingAmount = async (contactCode) => {
        try {
            const result = await lab4services.getContactOutStandingAmount(contactCode);
            console.log("loadOutStandingAmount:", result);
            if (result.code == 'OK' && result.data) {
                let contact = result.data.contact ? result.data.contact : null;
                if(contact){
                    setContact(contact);

                    if(contact.contact_name)
                        setContactName(contact.contact_name);
                    else if(contact.last_name){
                        if(contact.first_name)
                            setContactName(contact.first_name + " " + contact.last_name);
                        else
                            setContactName(contact.last_name);
                    }

                    if(contact.email_address)
                        setContactEmail(contact.email_address);
                }

                if(result.data.outstanding_amount)
                    setOutstandingAmount(result.data.outstanding_amount);
            }
        } catch (ex) {

        }
    }

    const initPayment = async (isLoading) => {
        onShowLoading(isLoading)
        if(contact && contact && outstandingAmount > 0){
            try {
                let body = {
                    contact_id: contact.id ? contact.id : null,
                    email_address: contactEmail ? contactEmail : null,
                    contact_code: contact.code ? contact.code : null,
                    amount: outstandingAmount,
                    type: 'NO_CAPTURE_CARD'
                };
                
                let result;
                if (connection.newApiFlow) result = await lab4services.initTopup(body);
                else result = await lab4services.initPayment(body);
                console.log("result initPayment ===", result);
                if (result.code === 'OK') {
                    let urlFormPaygate = document._portalConfig.urlFormPaygate;
                    if (result && result.code === 'OK' && result.data && result.data.client_token) {
                        setTopupMonthlyViaPaymentLink(true);
                        let clientToken = result.data.client_token;
                        var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                        console.log('splitToken:', splitToken);
                        if (splitToken.length > 0) {
                            var payRequestIDRes = splitToken[0];
                            var checkSumRes = splitToken[1];
                            var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                                + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                                + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                                + '</form>'
                            console.log('htmlContent:', htmlContent);
                            setHtmlContent(htmlContent);
                            setOpenProcessForm(true);
                        }
                    } else if (result.data && result.data.state === 'REJECTED') {
                        onShowMessage({
                            show: true,
                            message: t('INIT_PAYMENT_REJECTED'), 
                            isConfirm: true,
                            confirmAction: {
                                okAction: async () => await initPayment(true),
                                okTitle: t('btn_try'),
                                cancelTitle: t('btn_close'),
                                cancelAction: () => history.push(paths.home),
                            },
                        })
                    }
                } else {
                    onShowMessage({
                        show: true,
                        message: t('INIT_PAYMENT_FAILED'),
                        isConfirm: true,
                        confirmAction: {
                            okAction: async () => await initPayment(true),
                            okTitle: t('btn_try'),
                            cancelTitle: t('btn_close'),
                            cancelAction: () => history.push(paths.home),
                        },
                    });
                    return false;
                }
            } catch (ex) {
                console.log("initPayment exception ===", ex);
            }
        }
        onShowLoading(false)
    }

    console.log("PaymentLink message: ", message);
    return (
        <>
            <CustomHeader />
            <Stack direction={"row"} justifyContent={"center"} mt={"150px"}>
                <Box sx={{ width: "50%", p: "50px", boxShadow: "0 0 10px #dddddd", borderRadius: "20px" }}>
                    <Box>
                        <Typography textAlign={"center"} fontWeight={"600"} variant="h5">Hi {contactName}</Typography>
                        <Typography my={"15px"} textAlign={"center"} >The details for your payment are below</Typography>
                        <hr />
                    </Box>
                    <Stack direction={"row"} my={"40px"} gap={"10px"}>
                        <Stack width={"50%"} direction={"column"} gap={"10px"} alignItems={"end"}>
                            <Typography fontSize={"16px"}>{t('contact_code')}:</Typography>
                            <Typography fontSize={"16px"}>{t('email_address')}:</Typography>
                            <Typography fontSize={"16px"}>{t('outstanding_amount')}:</Typography>
                        </Stack>
                        <Stack width={"50%"} direction={"column"} gap={"10px"} alignItems={"start"}>
                            {contact && contact.code && <Typography fontSize={"16px"}>{contact.code}</Typography>}
                            {contactEmail && <Typography fontSize={"16px"}>{contactEmail}</Typography>}
                            {outstandingAmount > 0 && <Typography fontSize={"16px"} fontWeight={"700"}>R{outstandingAmount}</Typography>}
                        </Stack>
                    </Stack>
                    <hr />
                    <Box mt={"30px"} display={"flex"} justifyContent={"center"}>
                        {outstandingAmount && outstandingAmount > 0 
                            && <Button onClick={() => initPayment(true)} color='primary' sx={{ borderRadius: "20px", fontSize: "16px" }} variant='contained' >
                            {t('btn_continue_payment')}
                        </Button>}
                    </Box>
                </Box>
                {message && message.show && <CustomAlert
                    open={message.show}
                    message={message.message}
                    showButtonClose={true}
                    isConfirm={message.isConfirm ? message.isConfirm : null}
                    confirmAction={message.confirmAction ? message.confirmAction : null}
                    onClose={message.action ? message.action : () => onShowMessage({})}
                />}
                {showLoading && <CustomLoading open={showLoading} />}
                {openProcessForm && <ProcessFormView
                    open={openProcessForm}
                    onClose={() => setOpenProcessForm(false)}
                    html_content={htmlContent}
                />}
            </Stack>
            <CustomFooter />
        </>
    );
}